<template>
  <div>
    <div class="box-container">
      <p class="m-0 box-text text-color">To access Project Spectrum’s online courses, you must log into the Encite learning management platform. Because you are a registered Project Spectrum user, we have automatically generated your login credentials, which you see below.</p>
      <p class="m-0 box-text text-color">Clicking the course link will take you to the Encite login screen. You will need to copy/paste the system-generated password and log into the learning management platform.</p>
      <p class="m-0 m-3 box-text text-color">If you have issues or concerns,please contact us at <a href="mailto:support@projectspectrum.io">support@projectspectrum.io</a> for assistance.</p>
    </div>

    <div class="box-container box-credentials d-flex justify-content-center">
      <div style="min-width: 200px;" class="d-flex justify-content-center">
        <div class="w-auto d-flex flex-column align-items-start">
          <p class="w-auto m-0 box-text credentials-color">
            <b>Username</b> : {{ username }}
          </p>
          <p class="w-auto m-0 box-text credentials-color">
            <b>Password</b> :
            {{
              showPassword ? password : "*********************************"
            }}
            <i
              class="mdi mdi-content-copy"
              @click="copyPassword"
              :style="{
                cursor: 'pointer',
                color: copied ? 'red' : 'inherit',
              }"
              title="Click to Copy Password"
            ></i>
          </p>
          <b-form-checkbox v-model="showPassword">
            Show Password
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import { isLoggedIn } from "../../../utils/authentication";

  export default {
    data(){
      return {
        isLoggedIn: isLoggedIn(),
        username: "Loading...",
        password: "Loading...",
        enciteCredentialError: false,
        showPassword: false,
        copied: false,
      };
    },
    methods: {
      async getEnciteCredentials() {
        /*  API call to server: GET /api/encite/account  */
        axios
          .get("/api/encite/account")
          .then((response) => {
            this.enciteCredentialError = false;
            this.username = response.data.username;
            this.password = response.data.password;
          })
          .catch((error) => {
            this.enciteCredentialError = true;
            console.error(error);
          });
      },
      copyPassword() {
        navigator.clipboard
          .writeText(this.password)
          .then(() => {
            console.log("Password copied to clipboard")
          })
          .catch((err) => {
            console.error("Could not copy password: ", err)
          });
        this.copied = true;
      },
    },
    mounted() {
      if(this.isLoggedIn) {
        this.getEnciteCredentials();
      }
    }
  }
</script>

<style scoped>
  .box-container {
    width: 100%;
    height: auto;
  }

  .box-text {
    text-align: center;
    font-family: Rajdhani;
    font-size: clamp(14px, 2vw, 20px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .text-color {
    color: #000;
  }

  .box-credentials {
    border: 1px solid black;
    padding: 20px;
  }

  .credentials-color {
    color: #424EC4;
  }
</style>